import Product from './product';
import Messages from './messages';
import Coupon from './coupon';
import Totals from './totals';
import CouponsInfo from './coupons-info';
import GoodiesInfo from './goodies-info';


export default class Cart {
    constructor(data) {
        //console.log('cart constructor', data)
        this._canCheckout = data.hasOwnProperty('canCheckout') ? data.canCheckout : false;
        this._notAllowOrder = data.hasOwnProperty('notAllowOrder') ? data.notAllowOrder : false;
        this._immersivePoints = data.immersivePoints;
        this._setProducts(data);
        this.setCoupons(data);
        this._messages = new Messages(data);
        this._totals = new Totals(data);
        this._itemCount = data.hasOwnProperty('itemCount') ? data.itemCount : '0';
        this._couponsInfo = new CouponsInfo(data && data.hasOwnProperty('couponsInfo') ? data.couponsInfo : {});
        this._goodiesInfo = new GoodiesInfo(data && data.hasOwnProperty('goodiesInfo') ? data.goodiesInfo : {});
        this.data = data;
    }

    /**
     * Split product list by type
     *
     * @param {Object} data
     */
    _setProducts(data){
        this._purchaseProducts = [];
        //this._loyaltyProducts  = [];
        this._pointsProducts   = [];
        this._goodiesProducts  = [];
        if(!data.hasOwnProperty('items')){
            return;
        }
        data.items.forEach(product => {
            //console.log('product', product);
            let p = new Product(product);
            switch(p.type){
                case 1:
                    this._pointsProducts.push(p);
                    break;
                // case 10:
                //     this._loyaltyProducts.push(p);
                    //break;
                case 30:
                    this._goodiesProducts.push(p);
                    break;
                default:
                    this._purchaseProducts.push(p);
                    break;
            }
        });

        if(this._immersivePoints) {
          this._purchaseProducts = this._purchaseProducts.concat(this._pointsProducts);
        }

        //console.log('this._purchaseProducts', this._purchaseProducts);
    }

    /**
     * Set Coupons
     * @param {Object} data
     */
    setCoupons(data){
        this._coupons = [];
        if(!data.hasOwnProperty('coupons')){
            return;
        }
        data.coupons.forEach(coupon => {
            //console.log('coupon', coupon);
            this._coupons.push(new Coupon(coupon));
        });
    }

    get canCheckout(){
        return this._canCheckout;
    }

    get immersivePoints(){
      return this._immersivePoints;
    }

    get notAllowOrder(){
        return this._notAllowOrder;
    }

    get totals(){
        return this._totals;
    }

    get isClimatized(){
        return this.data.hasOwnProperty('climatized') ? this.data.climatized : false;
    }

    get id(){
        return this.data && this.data.hasOwnProperty('id') ? this.data.id : null;
    }

    get couponStart(){
        return this.data.hasOwnProperty('couponStart') ? this.data.couponStart : false;
    }

    get products(){
        return this._purchaseProducts;
    }

    get loyaltyProducts(){
        return []; //this._loyaltyProducts;
    }

    get pointsProducts(){
        return this._pointsProducts;
    }

    get pointsInfo(){
        return this.data.hasOwnProperty('pointsInfo') ? this.data.pointsInfo : null;
    }

    get goodiesProducts(){
        return this._goodiesProducts;
    }

    get goodiesInfo(){
        return this._goodiesInfo;
    }

    get goodiesAutoRemovedMsg(){
        return this._goodiesInfo.autoRemovedMsg;
    }

    get messages(){
        return this._messages;
    }

    get coupons(){
        return this._coupons;
    }

    get shipping(){
        return this._shipping;
    }

    get payment(){
        return this._payment;
    }

    get priorityHandling(){
        return this.data.hasOwnProperty('priority') ? this.data.priority : null;
    }

    get itemCount(){
        //return this._purchaseProducts.length;
        return this._itemCount;
    }

    get deliveryDate(){
        return this.data.hasOwnProperty('deliveryDate') ? this.data.deliveryDate : null;
    }

    get couponLevelInfo(){
        return this.data.hasOwnProperty('couponLevelInfo') ? this.data.couponLevelInfo : null;
    }

    get couponIdOffers(){
        return this.data.hasOwnProperty('couponIdOffers') ? this.data.couponIdOffers : null;
    }

    get couponAutoRemovedMsg(){
        return this.data.hasOwnProperty('couponAutoRemovedMsg') ? this.data.couponAutoRemovedMsg : null;
    }

    get couponSuccess(){
        return this.data.hasOwnProperty('couponSuccess') ? this.data.couponSuccess : null;
    }

    get streamerMessage(){
        return this.data.hasOwnProperty('streamerMessage') ? this.data.streamerMessage : null;
    }

    get isBlackRabbit(){
        return this.data.hasOwnProperty('isBlackRabbit') ? this.data.isBlackRabbit : null;
    }

    get peakSeasonAlert(){
        return this.data.hasOwnProperty('peakSeasonAlert') ? this.data.peakSeasonAlert : null;
    }

    get couponSuggestion(){
        return this._couponsInfo.suggestion;
    }

    get isGift(){
        return this.data.hasOwnProperty('isGift') ? this.data.isGift : false;
    }

    get showGift(){
        return this.data.hasOwnProperty('showGift') ? this.data.showGift : 0;
    }

    get giftData(){
        return this.data.hasOwnProperty('giftData') ? this.data.giftData : null;
    }

    get showButtonEmptyCart(){
        return this.data.hasOwnProperty('showButtonEmptyCart') ? this.data.showButtonEmptyCart : null;
    }

}
